/*eslint-disable */

import {bus} from '@/main';
import toast from '@/services/toast';

export default {
  name: 'approve-request-popup',
  components: {},
  props: ['joinNgoInfo', 'flag'],
  data () {
    return {
    }
  },
  computed: {

  },
  mounted () {
  },
  methods: {
    closeJoinRecord() {
      bus.$emit('joinRequestRecordModalBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    confirmJoinRecord(){
      if(this.flag == 'true'){
        var data = {
          public:false,
          active:false
        }
      }else{
        var data = {
          public:true,
          active:true
        }
      }
      this.$store.dispatch('updateLbilNgoRequestListFunc', {data:{id:this.joinNgoInfo.id, data:data}}).then((res) => {
        toast.success(res.data.msg);
        this.getngoListFun();
        this.closeJoinRecord();
      }).catch((err) => {
        toast.error(err.data.user_msg || err.data.msg);
      })
    },
    getngoListFun() {
      this.$store.dispatch('getLbilNgoListFunc')
      this.$store.dispatch('getLbilPublicNgoListFunc')
    },
  }
}